"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HddOutline = {
    name: 'hdd',
    theme: 'outline',
    nameWithTheme: 'hdd-o',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M786.5 131l-.1-.2c-6.5-20.2-25.1-33.8-46.3-33.8H277.9c-21.1 0-40.2 14-46.3 34v.1c-.4 1.3-34.3 122.8-67.7 243.2C96 618.7 96 620.4 96 621.8v257.4c0 27 22.1 49 49.2 49H878c27.1 0 49.2-22 49.2-48.9l.6-265.3-141.3-483zM864 672v193H159.2V672H864zm-3.4-63.2H162.5l126.4-448.6h440.3l131.4 448.6z'
            },
            children: []
        },
        {
            tag: 'path',
            attrs: {
                d: 'M588.4 825.7c17.4 0 31.6-14.2 31.6-31.6v-51.2c0-17.4-14.2-31.6-31.6-31.6-17.4 0-31.6 14.2-31.6 31.6v51.2c0 17.4 14.2 31.6 31.6 31.6zM691.2 825.7c17.4 0 31.6-14.2 31.6-31.6v-51.2c0-17.4-14.2-31.6-31.6-31.6-17.4 0-31.6 14.2-31.6 31.6v51.2c0 17.4 14.2 31.6 31.6 31.6zM793.6 825.7c17.4 0 31.6-14.2 31.6-31.6v-51.2c0-17.4-14.2-31.6-31.6-31.6-17.4 0-31.6 14.2-31.6 31.6v51.2c0 17.4 14.2 31.6 31.6 31.6z'
            },
            children: []
        }
    ]
};
exports.default = HddOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/outline/HddOutline.js
// module id = 1053
// module chunks = 0